module.exports = __webpack_public_path__ + "static/media/GitHub.38e57dc8.svg";